import $ from 'jquery';
import {updateTotal} from "./OrderForm.js";

// Генерация табов для социальных сетей и услуг
export function generateTabs(social, services, isActive = false) {
	const $tabsContainer = $('[data-select-list]');
	const $selectServices = $('[data-select-services]');

	if(isActive){
		$('.calc__block--first [data-select-title] .select__icon').attr('src', `/local/templates/neolikes/assets/images/socials/${social.toLowerCase()}.svg`);
		$('.calc__block--first [data-select-title] .select__value').text(social);
	}

	const $headerSelect = $(`<li class="select__option" data-select-option>
		<button class="select__button btn-res flex-align-center state-color ${isActive ? 'is-active' : ''}" data-option-inner-button="${social}">
			<img class="select__icon" src="/local/templates/neolikes/assets/images/socials/${social.toLowerCase()}.svg" width="26" height="26" alt="${social}" loading="lazy" decoding="auto" aria-hidden="true">
			<span class="select__value">${social}</span>
		</button>
	</li>`);

	const $selectContainer = $(`<div class="calc-services__tabs-buttons tabs__buttons flex-column ${isActive ? 'is-active' : ''}" data-tabs-buttons="${social}" data-option-inner-btn-target="${social}"></div>`);

	const availableServices = Object.entries(services || {})
		.filter(([, tariffs]) => Array.isArray(tariffs) && tariffs.some(tariff => tariff && tariff.NAME))
		.map(([service]) => service);

	availableServices.forEach((service, index) => {
		const tabId = `${social}-${service.toLowerCase()}`;
		const $select = $(`<button class="tabs__btn ${index === 0 ? 'tabs__btn--active' : ''}" data-tabs-path="${tabId}" role="tab">${service}</button>`);
		$selectContainer.append($select);
	});

	$tabsContainer.append($headerSelect);
	$selectServices.append($selectContainer);
}

// Переключение табов
export function initTabs() {
	$(document).on('click', '[data-calc] .tabs__btn', function () {
		const $this = $(this);
		const path = $this.data('tabs-path');
		$this.siblings().removeClass('tabs__btn--active');
		$this.addClass('tabs__btn--active');
		$(`.tabs__content[data-tabs-target="${path}"]`)
			.addClass('tabs__content--active')
			.siblings()
			.removeClass('tabs__content--active');
		updateTotal($('.calc__block--second .tabs-contents__data.is-active'));
	});
}
